//node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

const PaginationPrevComponent: FunctionComponent = () => {
  const handler = usePaginationContext();

  if (handler.disabled(1)) {
    return <Pagination.Prev disabled={true} />;
  }

  return (
    <NextLink href={handler.generatePath(handler.getPage() - 1)}>
      <Pagination.Prev />
    </NextLink>
  );
};

export default React.memo(PaginationPrevComponent);
